import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="note"
// Reveals the note editor on tap, hides the "＋ Note" / "Edit" triggers, and
// surfaces save feedback so people can see the note was persisted.
export default class extends Controller {
    static targets = ["editor", "trigger", "chip", "input", "status"]

    open(e) {
        e.preventDefault()
        this.editorTarget.classList.remove("hidden")
        this.triggerTargets.forEach(t => t.classList.add("hidden"))
        if (this.hasChipTarget) this.chipTarget.classList.add("hidden")
        if (this.hasInputTarget) {
            const input = this.inputTarget
            input.focus()
            input.setSelectionRange(input.value.length, input.value.length)
        }
    }

    saving() {
        clearTimeout(this.statusTimeout)
        this.setStatus("Saving…", "text-gray-400")
    }

    saved(e) {
        clearTimeout(this.statusTimeout)
        if (e.detail && e.detail.success === false) {
            this.setStatus("Couldn't save, try again", "text-red-500")
            return
        }
        this.setStatus("Saved ✓", "text-green-600")
        this.statusTimeout = setTimeout(() => this.setStatus("", "text-gray-400"), 2500)
    }

    setStatus(text, colorClass) {
        if (!this.hasStatusTarget) return
        this.statusTarget.textContent = text
        this.statusTarget.className = `text-sm ${colorClass}`
    }
}
